import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import classNames from "classnames";

// Local Imports
import HeaderComponent from "@components/organisms/header/header.component";
import HubHeaderComponent from "@components/organisms/hub-header/hub-header.component";
import { isHubToken } from "../../../utils/hub-sso";
import SideMenuComponent from "@components/organisms/sidemenu/sidemenu.component";
import AlertV2Component from "@atoms/alert/alert-v2.component";
import { APP_NAME, APP_VERSION } from "@constants/app.constants";
import { setAlert } from "@reducers/alert.reducer";
import "@core/scss/base/core/menu/menu-types/vertical-menu.scss";
import "@core/scss/base/core/menu/menu-types/vertical-overlay-menu.scss";
import AlertComponent from "@atoms/alert/alert.component";

const LayoutWrapperComponent = ({ children }) => {
  const [menuVisibility, setMenuVisibility] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { menuCollapsed } = useSelector((state) => state?.app);
  const { alertMessage, showAlert, type, title, message } = useSelector(
    (state) => state.alert
  );
  const hubToken = useSelector((state) => state.app.token);
  const dispatch = useDispatch();
  const location = useLocation();

  const hideAlert = () => {
    dispatch(setAlert({ alert: false }));
  };

  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    if (menuVisibility && windowWidth < 1200) {
      setMenuVisibility(false);
    }
  }, [location]);

  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth);
    }
  }, [windowWidth]);
  return (
    <div
      className={classNames(
        "wrapper vertical-layout navbar-floating footer-static",
        {
          // Modern Menu
          "vertical-menu-modern": windowWidth >= 1200,
          "menu-collapsed": menuCollapsed && windowWidth >= 1200,
          "menu-expanded": !menuCollapsed && windowWidth > 1200,

          // Overlay Menu
          "vertical-overlay-menu": windowWidth < 1200,
          "menu-hide": !menuVisibility && windowWidth < 1200,
          "menu-open": menuVisibility && windowWidth < 1200,

          // Hub SSO chrome: the suite header spans the full viewport, so the
          // fixed side menu has to start below it (hub-header injects the CSS).
          "hub-chrome": isHubToken(hubToken),
        }
      )}
      options={{ wheelPropagation: false }}
    >
      <SideMenuComponent setMenuVisibility={setMenuVisibility} />
      {/* Under Hub SSO the suite's own header is the chrome — product
          switcher, org chip, account menu, Sami — and the Vuexy navbar
          stays down: two headers is the drift the suite keeps un-shipping.
          A legacy local login keeps the Vuexy navbar untouched. */}
      {isHubToken(hubToken) ? (
        <HubHeaderComponent />
      ) : (
        <HeaderComponent setMenuVisibility={setMenuVisibility} />
      )}
      {children && (
        <>
          <div className="app-content content overflow-hidden">
            <div className="content-overlay"></div>
            <div className="header-navbar-shadow"></div>
            <div className="content-wrapper container-xxl p-0 animate__animated animate__fadeIn">
              <div className="row">
                <div className="col-sm-12">
                  {alertMessage && (
                    <AlertComponent
                      type={alertMessage.type}
                      message={alertMessage.message}
                    />
                  )}
                  {showAlert && (
                    <AlertV2Component
                      show={showAlert}
                      type={type}
                      title={title}
                      message={message}
                      hideAlert={hideAlert}
                    />
                  )}
                  {children}
                </div>
              </div>
            </div>
          </div>
          <footer className="footer footer-light footer-static">
            <p className="clearfix mb-0">
              <span className="float-md-start d-block d-md-inline-block mt-25">
                {APP_NAME} {APP_VERSION} © {new Date().getFullYear()}{" "}
              </span>
            </p>
          </footer>
        </>
      )}
    </div>
  );
};

export default LayoutWrapperComponent;
